export default {
    createWaitingRoom: {
        name: {
            value: '',
            isValid: true,
        },
        title: {
            value: '',
            isValid: true,
        },
        startDate: {
            value: '',
            isValid: true,
        },
        endDate: {
            value: '',
            isValid: true,
        },
        outflow: {
            value: '',
            isValid: true,
        },
        defaultReturnUrl: {
            value: '',
            isValid: true,
        },
        entranceValidityInMinutes: {
            value: '',
            isValid: true,
        },
    },
};
